import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FascicoloFull } from '../models/fascicolo/fascicolo-full';

@Injectable()
export class IntestazioneFascicoloService {
  public _notifyActionIntestazione: Subject<FascicoloFull> = new Subject<FascicoloFull>();
  public notifyActionIntestazione: Observable<FascicoloFull> = this._notifyActionIntestazione.asObservable();
}
